import { render, staticRenderFns } from "./70independenceday.vue?vue&type=template&id=63a14864&"
import script from "./70independenceday.vue?vue&type=script&lang=js&"
export * from "./70independenceday.vue?vue&type=script&lang=js&"
import style0 from "./70independenceday.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports